export default __webpack_public_path__ + "static/media/DashboardActiveIcon.12cc4a29.svg";